import Vue from "vue";
import Vuex from "vuex";

import _ from "lodash";
import axios from "axios";
// import config from "../config";
// import moment from "moment";

Vue.use(Vuex);

let co_webaccesstoken_temp = window.localStorage.getItem(
  "co_webaccesstoken_temp"
)
  ? window.localStorage.getItem("co_webaccesstoken_temp")
  : "";
let accesstoken = window.localStorage.getItem("accesstoken")
  ? window.localStorage.getItem("accesstoken")
  : "";
// console.log("accesstoken", accesstoken);
let refreshtoken = window.localStorage.getItem("refreshtoken")
  ? window.localStorage.getItem("refreshtoken")
  : "";

let defaultUser = {
  co_id: "",
  co_invoice_name: "",
  co_invoice_firstname: ""
};
let user = window.localStorage.getItem("user")
  ? JSON.parse(window.localStorage.getItem("user"))
  : _.cloneDeep(defaultUser);
let defaultAffiliatedUser = {
  us_id: "",
  us_login: ""
};
let affiliatedUser = window.localStorage.getItem("affiliatedUser")
  ? JSON.parse(window.localStorage.getItem("affiliatedUser"))
  : _.cloneDeep(affiliatedUser);

let items_countries = [
  {"value": "AFG", "text": "Afghanistan"},
  {"value": "ALB", "text": "Albania"},
  {"value": "DZA", "text": "Algeria"},
  {"value": "ASM", "text": "American Samoa"},
  {"value": "AND", "text": "Andorra"},
  {"value": "AGO", "text": "Angola"},
  {"value": "AIA", "text": "Anguilla"},
  {"value": "ATA", "text": "Antarctica"},
  {"value": "ATG", "text": "Antigua and Barbuda"},
  {"value": "ARG", "text": "Argentina"},
  {"value": "ARM", "text": "Armenia"},
  {"value": "ABW", "text": "Aruba"},
  {"value": "AUS", "text": "Australia"},
  {"value": "AUT", "text": "Austria"},
  {"value": "AZE", "text": "Azerbaijan"},
  {"value": "BHS", "text": "Bahamas (the)"},
  {"value": "BHR", "text": "Bahrain"},
  {"value": "BGD", "text": "Bangladesh"},
  {"value": "BRB", "text": "Barbados"},
  {"value": "BLR", "text": "Belarus"},
  {"value": "BEL", "text": "Belgium"},
  {"value": "BLZ", "text": "Belize"},
  {"value": "BEN", "text": "Benin"},
  {"value": "BMU", "text": "Bermuda"},
  {"value": "BTN", "text": "Bhutan"},
  {"value": "BOL", "text": "Bolivia (Plurinational State of)"},
  {"value": "BES", "text": "Bonaire, Sint Eustatius and Saba"},
  {"value": "BIH", "text": "Bosnia and Herzegovina"},
  {"value": "BWA", "text": "Botswana"},
  {"value": "BVT", "text": "Bouvet Island"},
  {"value": "BRA", "text": "Brazil"},
  {"value": "IOT", "text": "British Indian Ocean Territory (the)"},
  {"value": "BRN", "text": "Brunei Darussalam"},
  {"value": "BGR", "text": "Bulgaria"},
  {"value": "BFA", "text": "Burkina Faso"},
  {"value": "BDI", "text": "Burundi"},
  {"value": "CPV", "text": "Cabo Verde"},
  {"value": "KHM", "text": "Cambodia"},
  {"value": "CMR", "text": "Cameroon"},
  {"value": "CAN", "text": "Canada"},
  {"value": "CYM", "text": "Cayman Islands (the)"},
  {"value": "CAF", "text": "Central African Republic (the)"},
  {"value": "TCD", "text": "Chad"},
  {"value": "CHL", "text": "Chile"},
  {"value": "CHN", "text": "China"},
  {"value": "CXR", "text": "Christmas Island"},
  {"value": "CCK", "text": "Cocos (Keeling) Islands (the)"},
  {"value": "COL", "text": "Colombia"},
  {"value": "COM", "text": "Comoros (the)"},
  {"value": "COD", "text": "Congo (the Democratic Republic of the)"},
  {"value": "COG", "text": "Congo (the)"},
  {"value": "COK", "text": "Cook Islands (the)"},
  {"value": "CRI", "text": "Costa Rica"},
  {"value": "HRV", "text": "Croatia"},
  {"value": "CUB", "text": "Cuba"},
  {"value": "CUW", "text": "Curaçao"},
  {"value": "CYP", "text": "Cyprus"},
  {"value": "CZE", "text": "Czechia"},
  {"value": "CIV", "text": "Côte d'Ivoire"},
  {"value": "DNK", "text": "Denmark"},
  {"value": "DJI", "text": "Djibouti"},
  {"value": "DMA", "text": "Dominica"},
  {"value": "DOM", "text": "Dominican Republic (the)"},
  {"value": "ECU", "text": "Ecuador"},
  {"value": "EGY", "text": "Egypt"},
  {"value": "SLV", "text": "El Salvador"},
  {"value": "GNQ", "text": "Equatorial Guinea"},
  {"value": "ERI", "text": "Eritrea"},
  {"value": "EST", "text": "Estonia"},
  {"value": "SWZ", "text": "Eswatini"},
  {"value": "ETH", "text": "Ethiopia"},
  {"value": "FLK", "text": "Falkland Islands (the) [Malvinas]"},
  {"value": "FRO", "text": "Faroe Islands (the)"},
  {"value": "FJI", "text": "Fiji"},
  {"value": "FIN", "text": "Finland"},
  {"value": "FRA", "text": "France"},
  {"value": "GUF", "text": "French Guiana"},
  {"value": "PYF", "text": "French Polynesia"},
  {"value": "ATF", "text": "French Southern Territories (the)"},
  {"value": "GAB", "text": "Gabon"},
  {"value": "GMB", "text": "Gambia (the)"},
  {"value": "GEO", "text": "Georgia"},
  {"value": "DEU", "text": "Germany"},
  {"value": "GHA", "text": "Ghana"},
  {"value": "GIB", "text": "Gibraltar"},
  {"value": "GRC", "text": "Greece"},
  {"value": "GRL", "text": "Greenland"},
  {"value": "GRD", "text": "Grenada"},
  {"value": "GLP", "text": "Guadeloupe"},
  {"value": "GUM", "text": "Guam"},
  {"value": "GTM", "text": "Guatemala"},
  {"value": "GGY", "text": "Guernsey"},
  {"value": "GIN", "text": "Guinea"},
  {"value": "GNB", "text": "Guinea-Bissau"},
  {"value": "GUY", "text": "Guyana"},
  {"value": "HTI", "text": "Haiti"},
  {"value": "HMD", "text": "Heard Island and McDonald Islands"},
  {"value": "VAT", "text": "Holy See (the)"},
  {"value": "HND", "text": "Honduras"},
  {"value": "HKG", "text": "Hong Kong"},
  {"value": "HUN", "text": "Hungary"},
  {"value": "ISL", "text": "Iceland"},
  {"value": "IND", "text": "India"},
  {"value": "IDN", "text": "Indonesia"},
  {"value": "IRN", "text": "Iran (Islamic Republic of)"},
  {"value": "IRQ", "text": "Iraq"},
  {"value": "IRL", "text": "Ireland"},
  {"value": "IMN", "text": "Isle of Man"},
  {"value": "ISR", "text": "Israel"},
  {"value": "ITA", "text": "Italy"},
  {"value": "JAM", "text": "Jamaica"},
  {"value": "JPN", "text": "Japan"},
  {"value": "JEY", "text": "Jersey"},
  {"value": "JOR", "text": "Jordan"},
  {"value": "KAZ", "text": "Kazakhstan"},
  {"value": "KEN", "text": "Kenya"},
  {"value": "KIR", "text": "Kiribati"},
  {"value": "PRK", "text": "Korea (the Democratic People's Republic of)"},
  {"value": "KOR", "text": "Korea (the Republic of)"},
  {"value": "KWT", "text": "Kuwait"},
  {"value": "KGZ", "text": "Kyrgyzstan"},
  {"value": "LAO", "text": "Lao People's Democratic Republic (the)"},
  {"value": "LVA", "text": "Latvia"},
  {"value": "LBN", "text": "Lebanon"},
  {"value": "LSO", "text": "Lesotho"},
  {"value": "LBR", "text": "Liberia"},
  {"value": "LBY", "text": "Libya"},
  {"value": "LIE", "text": "Liechtenstein"},
  {"value": "LTU", "text": "Lithuania"},
  {"value": "LUX", "text": "Luxembourg"},
  {"value": "MAC", "text": "Macao"},
  {"value": "MDG", "text": "Madagascar"},
  {"value": "MWI", "text": "Malawi"},
  {"value": "MYS", "text": "Malaysia"},
  {"value": "MDV", "text": "Maldives"},
  {"value": "MLI", "text": "Mali"},
  {"value": "MLT", "text": "Malta"},
  {"value": "MHL", "text": "Marshall Islands (the)"},
  {"value": "MTQ", "text": "Martinique"},
  {"value": "MRT", "text": "Mauritania"},
  {"value": "MUS", "text": "Mauritius"},
  {"value": "MYT", "text": "Mayotte"},
  {"value": "MEX", "text": "Mexico"},
  {"value": "FSM", "text": "Micronesia (Federated States of)"},
  {"value": "MDA", "text": "Moldova (the Republic of)"},
  {"value": "MCO", "text": "Monaco"},
  {"value": "MNG", "text": "Mongolia"},
  {"value": "MNE", "text": "Montenegro"},
  {"value": "MSR", "text": "Montserrat"},
  {"value": "MAR", "text": "Morocco"},
  {"value": "MOZ", "text": "Mozambique"},
  {"value": "MMR", "text": "Myanmar"},
  {"value": "NAM", "text": "Namibia"},
  {"value": "NRU", "text": "Nauru"},
  {"value": "NPL", "text": "Nepal"},
  {"value": "NLD", "text": "Netherlands (the)"},
  {"value": "NCL", "text": "New Caledonia"},
  {"value": "NZL", "text": "New Zealand"},
  {"value": "NIC", "text": "Nicaragua"},
  {"value": "NER", "text": "Niger (the)"},
  {"value": "NGA", "text": "Nigeria"},
  {"value": "NIU", "text": "Niue"},
  {"value": "NFK", "text": "Norfolk Island"},
  {"value": "MNP", "text": "Northern Mariana Islands (the)"},
  {"value": "NOR", "text": "Norway"},
  {"value": "OMN", "text": "Oman"},
  {"value": "PAK", "text": "Pakistan"},
  {"value": "PLW", "text": "Palau"},
  {"value": "PSE", "text": "Palestine, State of"},
  {"value": "PAN", "text": "Panama"},
  {"value": "PNG", "text": "Papua New Guinea"},
  {"value": "PRY", "text": "Paraguay"},
  {"value": "PER", "text": "Peru"},
  {"value": "PHL", "text": "Philippines (the)"},
  {"value": "PCN", "text": "Pitcairn"},
  {"value": "POL", "text": "Poland"},
  {"value": "PRT", "text": "Portugal"},
  {"value": "PRI", "text": "Puerto Rico"},
  {"value": "QAT", "text": "Qatar"},
  {"value": "MKD", "text": "Republic of North Macedonia"},
  {"value": "ROU", "text": "Romania"},
  {"value": "RUS", "text": "Russian Federation (the)"},
  {"value": "RWA", "text": "Rwanda"},
  {"value": "REU", "text": "Réunion"},
  {"value": "BLM", "text": "Saint Barthélemy"},
  {"value": "SHN", "text": "Saint Helena, Ascension and Tristan da Cunha"},
  {"value": "KNA", "text": "Saint Kitts and Nevis"},
  {"value": "LCA", "text": "Saint Lucia"},
  {"value": "MAF", "text": "Saint Martin (French part)"},
  {"value": "SPM", "text": "Saint Pierre and Miquelon"},
  {"value": "VCT", "text": "Saint Vincent and the Grenadines"},
  {"value": "WSM", "text": "Samoa"},
  {"value": "SMR", "text": "San Marino"},
  {"value": "STP", "text": "Sao Tome and Principe"},
  {"value": "SAU", "text": "Saudi Arabia"},
  {"value": "SEN", "text": "Senegal"},
  {"value": "SRB", "text": "Serbia"},
  {"value": "SYC", "text": "Seychelles"},
  {"value": "SLE", "text": "Sierra Leone"},
  {"value": "SGP", "text": "Singapore"},
  {"value": "SXM", "text": "Sint Maarten (Dutch part)"},
  {"value": "SVK", "text": "Slovakia"},
  {"value": "SVN", "text": "Slovenia"},
  {"value": "SLB", "text": "Solomon Islands"},
  {"value": "SOM", "text": "Somalia"},
  {"value": "ZAF", "text": "South Africa"},
  {"value": "SGS", "text": "South Georgia and the South Sandwich Islands"},
  {"value": "SSD", "text": "South Sudan"},
  {"value": "ESP", "text": "Spain"},
  {"value": "LKA", "text": "Sri Lanka"},
  {"value": "SDN", "text": "Sudan (the)"},
  {"value": "SUR", "text": "Suriname"},
  {"value": "SJM", "text": "Svalbard and Jan Mayen"},
  {"value": "SWE", "text": "Sweden"},
  {"value": "CHE", "text": "Switzerland"},
  {"value": "SYR", "text": "Syrian Arab Republic"},
  {"value": "TWN", "text": "Taiwan"},
  {"value": "TJK", "text": "Tajikistan"},
  {"value": "TZA", "text": "Tanzania, United Republic of"},
  {"value": "THA", "text": "Thailand"},
  {"value": "TLS", "text": "Timor-Leste"},
  {"value": "TGO", "text": "Togo"},
  {"value": "TKL", "text": "Tokelau"},
  {"value": "TON", "text": "Tonga"},
  {"value": "TTO", "text": "Trinidad and Tobago"},
  {"value": "TUN", "text": "Tunisia"},
  {"value": "TUR", "text": "Turkey"},
  {"value": "TKM", "text": "Turkmenistan"},
  {"value": "TCA", "text": "Turks and Caicos Islands (the)"},
  {"value": "TUV", "text": "Tuvalu"},
  {"value": "UGA", "text": "Uganda"},
  {"value": "UKR", "text": "Ukraine"},
  {"value": "ARE", "text": "United Arab Emirates (the)"},
  {"value": "GBR", "text": "United Kingdom of Great Britain and Northern Ireland (the)"},
  {"value": "UMI", "text": "United States Minor Outlying Islands (the)"},
  {"value": "USA", "text": "United States of America (the)"},
  {"value": "URY", "text": "Uruguay"},
  {"value": "UZB", "text": "Uzbekistan"},
  {"value": "VUT", "text": "Vanuatu"},
  {"value": "VEN", "text": "Venezuela (Bolivarian Republic of)"},
  {"value": "VNM", "text": "Viet Nam"},
  {"value": "VGB", "text": "Virgin Islands (British)"},
  {"value": "VIR", "text": "Virgin Islands (U.S.)"},
  {"value": "WLF", "text": "Wallis and Futuna"},
  {"value": "ESH", "text": "Western Sahara"},
  {"value": "YEM", "text": "Yemen"},
  {"value": "ZMB", "text": "Zambia"},
  {"value": "ZWE", "text": "Zimbabwe"},
  {"value": "ALA", "text": "Åland Islands"}
];

let items_civility = [
  {
    value: "Mme",
    text: "Mme"
  },
  {
    value: "M",
    text: "M."
  }
];

let items_pa_state = [
  {
    value: "TO_PREPARE",
    text: "à préparer"
  },
  {
    value: "PREPARING",
    text: "en cours de préparation"
  },
  {
    value: "SENT",
    text: "expédiée"
  },
  {
    value: "SENT_BACK_AFTER_FAILURE",
    text: "retournée après échec de livraison"
  },
  {
    value: "RECEIVED",
    text: "livrée"
  }
];

let items_deliverycompany = [
  {
    value: "colissimo",
    text: "Colissimo"
  },
  {
    value: "mondialrelay",
    text: "Mondial Relay"
  },
  {
    value: "mondialrelay_locker",
    text: "Mondial Relay Locker"
  }
];

let items_cr_statuses = [
  {
    text: 'Demande reçue',
    value: 'INITIAL'
  }, {
    text: 'Retour du matériel attendu',
    value: 'WAITING_KIT_BACK'
  }, {
    text: 'Demande en attente de confirmation',
    value: 'REQUEST_SUSPENDED'
  }, {
    text: 'Demande annulée',
    value: 'REQUEST_CANCELLED'
  }, {
    text: 'Kit reçu et complet - tests à venir',
    value: 'KIT_BACK_COMPLETE'
  }, {
    text: 'Kit reçu — éléments manquants demandés',
    value: 'KIT_BACK_INCOMPLETE'
  }, {
    text: 'Kit reçu - relance éléments manquants',
    value: 'KIT_STILL_INCOMPLETE'
  }, {
    text: 'Résiliation confirmée',
    value: 'SUBSCRIPTION_CANCELLED'
  }, {
    text: 'Matériel reçu - dysfonctionnements',
    value: 'KIT_TEST_KO'
  }, {
    text: 'Résiliation confirmée',
    value: 'KIT_INVOICE_PAID'
  }, {
    text: 'Résiliation confirmée',
    value: 'KIT_INVOICE_DISPUTED'
  }, {
    text: 'Commentaire interne',
    value: 'INTERNAL_COMMENT'
  }
];

let items_cr_reasons = [
  {
    text: 'Le bénéficiaire du service est décédé',
    value: 'REASON_DECEASED'
  }, {
    text: 'Je ne suis pas satisfait(e) du service',
    value: 'REASON_DISSATISFIED'
  }, {
    text: 'Je n\'ai plus l\'utilité du service',
    value: 'REASON_USELESS'
  }, {
    text: 'Le bénéficiaire du service déménage en EHPAD ou en résidence sénior',
    value: 'REASON_MOVED'
  }, {
    text: 'Le bénéficiaire a du mal à utiliser le service',
    value: 'REASON_USABILITY'
  }, {
    text: 'Le kit Emotivi ne fonctionne pas/plus',
    value: 'REASON_MALFUNCTION'
  }, {
    text: 'Autre',
    value: 'REASON_OTHER'
  }, {
    text: 'Je sollicite une assistance/information',
    value: 'CALL_ME_BACK'
  }, {
    text: 'Je ne souhaite pas d\'assistance/information',
    value: 'CANCEL'
  }, {
    text: 'Le bénéficiaire n\'est plus en mesure de décrocher lors d\'un appel',
    value: 'PICKUP'
  }, {
    text: `L'état de santé du bénéficiaire ne lui permet de plus de communiquer en visio`,
    value: 'COMMUNICATION'
  }, {
    text: `Autre`,
    value: 'OTHER'
  }, {
    text: 'Vous n\'êtes pas parvenu à configurer le kit Emotivi',
    value: 'NOT_WELL_CONFIGURED'
  }, {
    text: 'Un message indique que la box n\'est pas connectée quand vous souhaitez appeler',
    value: 'NOT_CONNECTED'
  }, {
    text: 'Le bénéficiaire à recemment changé de téléviseur',
    value: 'TV_CHANGED'
  }, {
    text: 'Lors d\'un appel, le téléviseur du bénéficiaire reste sur le canal TV (ou ne s\'allume pas)',
    value: 'NO_SWITCH_TO_EMOTIVI'
  }, {
    text: 'Le téléviseur ne rebascule pas sur la chaine TV à l\'issue de l\'appel',
    value: 'NO_SWITCH_TO_TV'
  }, {
    text: 'Lors d\'un appel le téléviseur bascule bien sur la source HDMI mais l\'écran reste noir',
    value: 'BLACK_HDMI_SCREEN'
  }, {
    text: 'La qualité de l\'appel (son, image) se dégrade au bout d\'un certain temps',
    value: 'POOR_CALL_QUALITY'
  }, {
    text: `Autre`,
    value: 'OTHER'
  }
]

// console.log("user", user);

/* let items_0A10 = [
  { value: 0, text: "0" },
  { value: 1, text: "1" },
  { value: 2, text: "2" },
  { value: 3, text: "3" },
  { value: 4, text: "4" },
  { value: 5, text: "5" },
  { value: 6, text: "6" },
  { value: 7, text: "7" },
  { value: 8, text: "8" },
  { value: 9, text: "9" },
  { value: 10, text: "10" }
]; */

/* let items_civility_simple = [
  {
    value: "mme",
    text: "Madame",
    sex: 2
  },
  {
    value: "m",
    text: "Monsieur",
    sex: 1
  }
]; */

export default new Vuex.Store({
  state: {
    co_webaccesstoken_temp,
    items_civility: items_civility,
    items_countries: items_countries,
    items_pa_state: items_pa_state,
    items_deliverycompany: items_deliverycompany,
    items_cr_statuses: items_cr_statuses,
    items_cr_reasons: items_cr_reasons,
    // lang,
    items: {},
    itemsloaded: false,
    traductionsloaded: false,
    myactions: [],
    isMainLoading: false,
    currentcontact: null,
    // lastcoid: "",
    mysocket: null,
    connected: false,
    accesstoken,
    refreshtoken,
    user,
    preferences: {
      personal: {},
      shared: {},
      rights: {}
    },
    reload_actions: 0,
    inputOpened: null,
    dialogErr: false,
    dialogErrTxt: "",
    socketmessage: {},
    affiliatedUser,
    authenticated: false,
    paymentMethodsStatusText: {
      fulfilled: "Le mode de paiement a été créé et finalisé.",
      flow_created:
        "L'interface d'enregistrement du mode de paiement a été créée.",
      flow_visited:
        "L'interface d'enregistrement du mode de paiement a été consultée",
      flow_exited:
        "L'utilisateur a quitté l'interface d'enregistrement du mode de paiement.",
      collect_customer_details: "Les informations du client ont été rassemblées.",
      collect_bank_account:
        "Les coordonnées bancaires ont été collectées pour cette demande de facturation.",
      payer_details_confirmed:
        "Le payeur a confirmé toutes ses coordonnées pour cette demande de facturation.",
      bank_authorisation_visited:
        "Un lien d'autorisation bancaire pour cette demande de facturation a été consulté.",
      bank_authorisation_authorised:
        "Une autorisation bancaire pour cette demande de facturation a été autorisée par le payeur.",
      bank_authorisation_denied:
        "Une autorisation bancaire pour cette demande de facturation a expiré",
      bank_authorisation_expired:
        "Une autorisation bancaire pour cette demande de facturation a été refusée par le payeur.",
      bank_authorisation_failed:
        "Une autorisation bancaire pour cette demande de facturation a échoué en raison d'une incompatibilité de compte bancaire.",
      cancelled: "Ce mode de paiement a été annulé.",
      created: "Le mode de paiement a été créé",
      failed: "Problème de paiement",
      submitted: "Le paiement a été soumis aux banques"
    },
    subscriptionStatusText: {
      created: "L'abonnement a été créé.",
      customer_approval_granted:
        "L'abonnement nécessitait une approbation supplémentaire de la part du client avant de pouvoir devenir actif, et cette approbation a été accordée.",
      customer_approval_denied:
        "L'abonnement nécessitait une approbation supplémentaire de la part du client avant de pouvoir devenir actif, et cette approbation a été refusée.",
      payment_created: "Un paiement a été créé par cet abonnement.",
      cancelled:
        "Cet abonnement a été annulé. Aucun autre paiement ne sera créé.",
      finished:
        "Cet abonnement est terminé. Aucun autre paiement ne sera créé.",
      paused: "Cet abonnement a été suspendu.",
      resumed: "Cet abonnement a redémarré."
    },
    paymentsStatusText: {
      pending_submission:
        "Le paiement a été créé, mais pas encore soumis aux banques",
      pending_customer_approval:
        "Nous attendons que le client approuve ce paiement",
      submitted: "Le paiement a été soumis à la banque du client",
      confirmed: "Le paiement a été validé par la banque du client",
      paid_out: "Le paiement a été envoyé sur le compte bancaire du créancier",
      cancelled: "Le paiement a été annulé",
      customer_approval_denied:
        "Le client a refusé l'approbation du paiement. Vous devez contacter directement le client",
      failed: "Le paiement n'a pas pu être traité.",
      charged_back: "Le paiement a été remboursé",
      succeeded: "Paiement réussi"
    }
  },
  mutations: {
    set_co_webaccesstoken_temp(state, co_webaccesstoken_temp) {
      state.co_webaccesstoken_temp = co_webaccesstoken_temp;
      window.localStorage.setItem(
        "co_webaccesstoken_temp",
        co_webaccesstoken_temp
      );
    },
    set_lang(state, lang) {
      window.localStorage.setItem("pvn_lang", lang);
      state.lang = lang;
    },
    set_traductions(state, data) {
      for (let itrad = 0; itrad < data.traductions.length; itrad++) {
        const trad = data.traductions[itrad];
        state.traductions_fr.translation[trad.tr_key] = trad.tr_fr;
        state.traductions_en.translation[trad.tr_key] = trad.tr_en;
        state.traductions_sp.translation[trad.tr_key] = trad.tr_sp;
        state.traductions_ru.translation[trad.tr_key] = trad.tr_ru;
        state.traductions_it.translation[trad.tr_key] = trad.tr_it;
      }
      state.traductionsloaded = true;
    },
    set_myactions(state, data) {
      state.myactions = data;
    },
    set_socketmessage(state, data) {
      state.socketmessage = data;
    },
    set_inputOpened(state, input) {
      if (input) {
        if (state.inputOpened && input.name !== state.inputOpened.name) {
          state.inputOpened.hideDropdown();
        }
        state.inputOpened = input;
      } else {
        state.inputOpened = null;
      }
    },
    set_mainisloading(state, ok) {
      state.isMainLoading = ok;
    },
    // set_lastcoid(state, co_id) {
    //   state.lastcoid = co_id;
    // },
    set_mysocket(state, socket) {
      state.mysocket = socket;
    },
    set_reload_actions(state) {
      state.reload_actions = Math.random();
    },
    // utiliser simplement pour mettre à jour les infos essentielles
    set_user_simple(state, user) {
      state.user.co_name = user.co_name;
      state.user.co_firstname = user.co_firstname;
      state.user.co_type = user.co_type;
      state.user.updatedAt = user.updatedAt;
    },
    set_connexion(state, what) {
      if (!what) {
        axios.defaults.headers.common["x-auth-accesstoken"] = "";
        window.localStorage.removeItem("accesstoken");
        state.accesstoken = null;
        window.localStorage.removeItem("refreshtoken");
        state.refreshtoken = null;
        window.localStorage.removeItem("user");
        state.user = _.cloneDeep(defaultUser);
        //console.log("state.user", state.user);
        state.connected = false;
        // this.dispatch("socketunjoinroom");
        return;
      }
      // console.log("what", what);
      // console.log("token, refreshtoken, user", what.accesstoken, what.refreshtoken, what.user);
      axios.defaults.headers.common["x-auth-accesstoken"] = what.accesstoken;
      window.localStorage.setItem("accesstoken", what.accesstoken);
      state.accesstoken = what.accesstoken;
      //window.localStorage.setItem("refreshtoken", what.refreshtoken);
      //state.refreshtoken = what.refreshtoken;
      what.user.co_password = "";
      window.localStorage.setItem("user", JSON.stringify(what.user));
      state.user = _.cloneDeep(what.user);
      if (state.affiliatedUser) {
        state.affiliatedUser = {};
        state.authenticated = false;
        window.localStorage.removeItem("affiliatedUser");
      }
      // state.preferences = _.cloneDeep(what.preferences);
      // console.log("what.preferences", what.preferences);
      /*       _.each(what.preferences.items, (val, key) => {
        state[key] = what.preferences.items[key];
      }); */

      state.connected = true;
      // this.dispatch("load_nbclientsuivi");
    },
    set_dialog_error(state, what) {
      // console.log("what", what);
      state.dialogErr = what.dialogErr;
      state.dialogErrTxt = what.dialogErrTxt;
    },
    set_authentification(state, what) {
      if (!what) {
        axios.defaults.headers.common["x-auth-accesstoken"] = "";
        state.accesstoken = null;
        window.localStorage.removeItem("accesstoken");
        state.affiliatedUser = _.cloneDeep(defaultAffiliatedUser);
        state.authenticated = false;
        return;
      }
      axios.defaults.headers.common["x-auth-accesstoken"] = what.accesstoken;
      window.localStorage.setItem("accesstoken", what.accesstoken);
      state.accesstoken = what.accesstoken;
      what.affiliatedUser.us_password = "";
      window.localStorage.setItem(
        "affiliatedUser",
        JSON.stringify(what.affiliatedUser)
      );
      state.affiliatedUser = _.cloneDeep(what.affiliatedUser);

      state.authenticated = true;

      if (state.user) {
        state.user = {};
        state.connected = false;
        window.localStorage.removeItem("user");
      }
      // this.dispatch("load_nbclientsuivi");
    }
  },
  actions: {
    showDialogError(ctx, err) {
      ctx.commit("set_dialog_error", {
        dialogErr: err ? true : false,
        dialogErrTxt: err ? err : ""
      });
    }
    // SOCKET_connect(ctx) {
    //   // if (ctx.state.user && ctx.state.user.co_id && ctx.state.mysocket)
    //   //   ctx.state.mysocket.emit("join", ctx.state.user.co_id);
    // },
    // SOCKET_message(ctx, data) {
    //   ctx.commit("set_socketmessage", data);
    //   ctx.dispatch("updateNbNewMessages");
    // },

    // socketjoinroom(ctx) {
    //   if (ctx.state.user && ctx.state.user.co_id)
    //     this._vm.$socket.emit("join", ctx.state.user.co_id);
    // },
    // socketunjoinroom(ctx) {
    //   this._vm.$socket.emit("unjoin", ctx.state.user.co_id);
    // }
  },
  modules: {},
  getters: {
    get_inputOpened(state) {
      return state.inputOpened;
    }
  }
});
